import { LocationGeusDataItem } from './location-geus-data-item';

export class LocationGeusData {
    public data: LocationGeusDataItem[] = [];
    public total: number;

    public constructor(init: Partial<LocationGeusData>) {
        Object.assign(this, init);
    }
}

export class LocationGeusDataV2 {
    public data: LocationGeusDataItem | null = null;

    public constructor(init: Partial<LocationGeusDataV2>) {
        Object.assign(this, init);
    }
}
